/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type EstimateMarginOfferMutationMutationVariables = Types.Exact<{
	input: Types.EstimateMarginOfferRequest;
}>;

export type EstimateMarginOfferMutationMutation = {
	__typename?: "Mutation";
	estimateMarginOffer: {
		__typename?: "MarginEstimateOfferResponse";
		underlyingAssetId: string;
		tradeFiatId: string;
		positionStatus: Types.PositionStatus;
		possibleLeverages: Array<number>;
		totalPosition: {
			__typename?: "Position";
			assetId: string;
			borrowedFundsInFiat: string;
			borrowedFundsInUnderlyingAsset: string;
			totalPositionInFiat: string;
			liquidationPriceInFiat: string;
			liquidationThresholdPercentage: string;
			healthIndicator: Types.MarginHealthIndicator;
			marginLevel: string;
			marginMinimum: string;
			marginMaximum: string;
			leverage: string;
			leverageDirection: Types.LeverageDirection;
			healthThreshold: { __typename?: "HealthThreshold"; high: string; low: string };
		};
		positionChange?:
			| {
					__typename: "MarginPositionDecrease";
					decreasedPosition?: {
						__typename?: "DecreasedPosition";
						repayingFundsInUnderlyingAsset: string;
						repayingFundsInFiat: string;
						receivedFunds: string;
					} | null;
			  }
			| {
					__typename: "MarginPositionIncrease";
					addedPosition?: {
						__typename?: "IncreasedPosition";
						borrowedFundsInUnderlyingAsset: string;
						totalPositionInFiat: string;
						leverage: string;
					} | null;
			  }
			| null;
		marginAppropriateness: {
			__typename?: "MarginEstimateAppropriateness";
			status: boolean;
			label: string;
			coolOffEnd?: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number } | null;
		};
		serverTime: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number };
	};
};

export const EstimateMarginOfferMutationDocument = gql`
	mutation estimateMarginOfferMutation($input: EstimateMarginOfferRequest!) {
		estimateMarginOffer(request: $input) {
			underlyingAssetId
			tradeFiatId
			positionStatus
			possibleLeverages
			totalPosition {
				assetId
				borrowedFundsInFiat
				borrowedFundsInUnderlyingAsset
				totalPositionInFiat
				liquidationPriceInFiat
				liquidationThresholdPercentage
				healthIndicator
				healthThreshold {
					high
					low
				}
				marginLevel
				marginMinimum
				marginMaximum
				leverage
				leverageDirection
			}
			positionChange {
				__typename
				... on MarginPositionIncrease {
					addedPosition {
						borrowedFundsInUnderlyingAsset
						totalPositionInFiat
						leverage
					}
				}
				... on MarginPositionDecrease {
					decreasedPosition {
						repayingFundsInUnderlyingAsset
						repayingFundsInFiat
						receivedFunds
					}
				}
			}
			marginAppropriateness {
				status
				label
				coolOffEnd {
					iso8601
					unixTimestamp
				}
			}
			serverTime {
				iso8601
				unixTimestamp
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class EstimateMarginOfferMutationGQLService extends Apollo.Mutation<
	EstimateMarginOfferMutationMutation,
	EstimateMarginOfferMutationMutationVariables
> {
	document = EstimateMarginOfferMutationDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
